/**
 * Caminhos da área Workflows (AB#86605), antes chamada Agents.
 *
 * As rotas antigas (`/agents...`) continuam respondendo com redirecionamento,
 * para links salvos e favoritos não quebrarem.
 */
export const WORKFLOWS_PATH = "/workflows";

export function workflowSettingsPath(id: string): string {
  return `${WORKFLOWS_PATH}/${encodeURIComponent(id)}/settings`;
}

/** `/agents`, `/agents/new` e `/agents/:id/settings` no caminho novo equivalente. */
export function legacyAgentsPathToWorkflows(pathname: string): string {
  const settings = /^\/agents\/([^/]+)\/settings\/?$/.exec(pathname);
  if (settings && settings[1] !== "new") return workflowSettingsPath(decodeURIComponent(settings[1]));
  return WORKFLOWS_PATH;
}
